import React,{ useCallback, useRef, useEffect } from 'react'
import {ButtonToolbar,Button,ButtonGroup, Drawer} from 'rsuite';
import Webcam from "react-webcam";

export const AccessMediaPrompt= ({onCancel, onAccessGranted, promptText, icon}) => {

    return (
        <div>
           <br/>
           <div className="access-pic-body">
            <div className="child-one">{icon ? icon : null}</div>
            <p className="child-two">{promptText}</p>
           </div>
           <br/><br/>          
           <ButtonToolbar>
            <ButtonGroup className="buttongroup-two">
                <Button className="child" onClick={onAccessGranted}>Разрешавам</Button>
                <div className="seperator"></div>
                <Button className="child" onClick={onCancel}>Забранявам</Button>              
            </ButtonGroup>
          </ButtonToolbar> 
        </div>
    )
}

// custom drawer to fit the width of the mobile layout in the middle of the screen
export const CustomDrawerMedia = ({onClose, show, sizedraw, children, title}) => {     

    return(   
        <Drawer        
          className="customDrawerMedia" // custome className to modify the style
          placement={'bottom'}
          show={show}
          onHide={onClose}  
          autoFocus={true}        
          size={sizedraw} // for fullscreen use lg,md,sm,xs
        >      
          <Drawer.Header >
            <Drawer.Title style={{color:"white"}}>{title}</Drawer.Title>
          </Drawer.Header>
          <Drawer.Body>
            {children}
          </Drawer.Body>
          <Drawer.Footer>
            {/* <Button onClick={close} appearance="primary">
              Confirm
            </Button>
            <Button onClick={close} appearance="subtle">
              Cancel
            </Button> */}
          </Drawer.Footer>  
        </Drawer>              
    )
}

export const dataUrlToFile =  async (dataUrl, fileName) => {
    const res  = await fetch(dataUrl);
    const blob = await res.blob();
    return new File([blob], fileName, { type: 'image/png' });
}

export const blobToFile = (data, fileName, contentType) => {
    contentType = contentType === "application/pdf" ? "application/pdf" : "text/xml";
    return new File([data], fileName, { type: contentType });
}

const videoConstraints = {
    width: 300,
    height: 300,
    facingMode: "user"
  };
  
export const WebcamCapture = ({onCapture, onCancel}) => {

    const webcamRef = useRef(null);

    const capture = useCallback(
        () => {
        const imageSrc = webcamRef.current.getScreenshot();
        onCapture(imageSrc);
        },
        [webcamRef, onCapture]
    );

    return (
        <>
        <Webcam
            audio={false}
            height={300}
            ref={webcamRef}
            screenshotFormat="image/png"
            width={300}
            videoConstraints={videoConstraints}
        /><br/>
        <Button onClick={capture} active >Capture photo</Button>
        <Button onClick={onCancel} style={{marginLeft:"8px"}}>Cancel</Button>
        </>
    );
};  

export const UploadPicture = ({onChange}) => {
    
    const fileInput = useRef(null);

    useEffect(()=>{
        if(fileInput.current) {
            setTimeout(()=>{fileInput.current.click()}, 10)
            
            fileInput.current.addEventListener('click', ()=>{
            
                document.body.onfocus = function(){         //this is to detect cancel event
                    document.body.onfocus = null;
                    setTimeout(function(){
                        if (fileInput?.current){
                           // console.log("Cancel clicked");
                            onChange(null);
                        } 
                    }, 300);
                };
            })
        }

    }, [fileInput, onChange]);  //do not add onChange to dependancy array or add the function in the parrent in useCallback

    // useEffect(()=>{
    //     if(image?.file) {
    //         const fr = new FileReader();
			
	// 		fr.addEventListener("load", () => {
    //             // convert image file to base64 string
	// 		    const res = fr.result;
    //             onChange({data: res, file:image.file, contentType: image.contentType})
    //         }, false);

    //         fr.readAsDataURL(image.file);

    //     }

    // }, [image, onChange]);

    const changeHandler = (event) => {
        const file = event.target.files[0];
        onChange({file: file, contentType: file.type})

    }

    return (
        <>
            <input ref={fileInput} type='file' className="upload-input-hide" onChange={changeHandler}
                   accept = 'image/gif, image/jpeg, image/bmp, image/jpg, image/png, image/tif, .pdf' />
        </>
    )
}

// Hook
// function useEventListener(eventName, handler, element = window) {
//     // Create a ref that stores handler
//     const savedHandler = useRef();
//     // Update ref.current value if handler changes.
//     // This allows our effect below to always get latest handler ...
//     // ... without us needing to pass it in effect deps array ...
//     // ... and potentially cause effect to re-run every render.
//     useEffect(() => {
//       savedHandler.current = handler;
//     }, [handler]);
//     useEffect(
//       () => {
//         // Make sure element supports addEventListener
//         // On
//         const isSupported = element && element.addEventListener;
//         if (!isSupported) return;
//         // Create event listener that calls handler function stored in ref
//         const eventListener = (event) => savedHandler.current(event);
//         // Add event listener
//         element.addEventListener(eventName, eventListener);
//         // Remove event listener on cleanup
//         return () => {
//           element.removeEventListener(eventName, eventListener);
//         };
//       },
//       [eventName, element] // Re-run if eventName or element changes
//     );
//   }